module.exports = __webpack_public_path__ + "img/icon-dwgg.e8b0de55.png";